import { render, staticRenderFns } from "./PersonalEquipamiento.vue?vue&type=template&id=6c15cd2a&scoped=true"
import script from "./PersonalEquipamiento.vue?vue&type=script&lang=js"
export * from "./PersonalEquipamiento.vue?vue&type=script&lang=js"
import style0 from "./PersonalEquipamiento.vue?vue&type=style&index=0&id=6c15cd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15cd2a",
  null
  
)

export default component.exports